exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ratingButton__ratingButton___1enjR {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  height: 48px;\n  background-color: #F9A826;\n  border: none;\n  border-radius: 6px;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease; }\n  .ratingButton__ratingButton___1enjR:hover, .ratingButton__ratingButton___1enjR:focus {\n    background-color: #E89A20;\n    color: #fff;\n    border: none; }\n  .ratingButton__ratingButton___1enjR:active {\n    background-color: #D88E1A;\n    color: #fff; }\n\n.ratingButton__starIcon___UfC9b {\n  font-size: 16px; }\n", ""]);

// exports
exports.locals = {
	"ratingButton": "ratingButton__ratingButton___1enjR",
	"starIcon": "ratingButton__starIcon___UfC9b"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/RatingButton/ratingButton.scss
// module id = 4492
// module chunks = 6